export default __webpack_public_path__ + "static/media/logo2.98269991.jpg";